import apiClient from '@/services/axios'

export async function patch(calenderEntryId, calendarDatesByDateList) {
  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setup-calendar-entries/' + calenderEntryId + '/calendar-dates-by-date-list', calendarDatesByDateList);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to post yearly entry.')
}
